import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { underline } from 'chaoskit/src/assets/styles/utility/text'

import { styles } from './utilities'

import Data from '~components/Data'

export function ContentTitle({
  children,
  as: Component = 'h3',
  variation = 'base',
  ...rest
}) {
  const theme = useTheme()

  return (
    <Component
      css={[
        variation === 'inset' && {
          marginTop: theme.space.xlarge,
        },
        {
          textAlign: 'center',
          fontFamily: styles.font.sans,
          fontWeight: variation === 'inset' ? 400 : theme.fontWeight.bold,
          fontSize: theme.fontSize['2xlarge'],

          [theme.mq.medium]: {
            fontSize:
              variation === 'base'
                ? theme.fontSize['5xlarge']
                : theme.fontSize['3xlarge'],
            textAlign: 'left',
          },

          [theme.mq.small__max]: {
            br: {
              display: 'none',
            },
          },

          span: {
            fontWeight: 100,
          },
        },
      ]}
      {...rest}
    >
      <Data>{children}</Data>
    </Component>
  )
}

ContentTitle.propTypes = {
  children: PropTypes.node,
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  variation: PropTypes.oneOf(['base', 'inset']),
}

export function ContentGrid(props) {
  const theme = useTheme()

  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: theme.space.large,

        'a:not(.SOCE__CustomerLink)': [underline],

        [theme.mq.medium]: {
          gridTemplateColumns: '1fr 2fr',

          '> :only-child': {
            gridColumn: '2 / span 1',
          },
        },
      }}
      {...props}
    />
  )
}
